import React from "react";

const SoftSection = () => {
  return (
    <section className="section section-soft story-section">
      <div className="container">
        <div className="section-heading">
          <p className="eyebrow">The Solution</p>
        </div>
        <div className="split-grid reverse-on-mobile">
          <div>
            <h2>
              Your personal Career Manager applies, follows up, and tracks
              everything.
            </h2>
            <p>
              Human guidance plus AI-assisted execution helps you focus on
              interviews while Lovapex handles applications, recruiter outreach,
              tailored resumes, and weekly updates.
            </p>
            <div className="feature-grid compact">
              <section className="card">
                <h3>Career manager</h3>
                <p>A dedicated partner keeps your search focused and moving.</p>
              </section>
              <section className="card">
                <h3>Tailored resumes</h3>
                <p>Every application is matched to the role and ATS-ready.</p>
              </section>
              <section className="card">
                <h3>Recruiter outreach</h3>
                <p>Targeted follow-ups put your profile in front of decision-makers.</p>
              </section>
            </div>
          </div>
          <div
            className="section-image solution-image"
            aria-label="Career manager helping a candidate"
          ></div>
        </div>
      </div>
    </section>
  );
};

export default SoftSection;
